import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HOST } from "../../../config/endpoints.config";
import { of } from "rxjs";
import { catchError, delay, map, retryWhen, tap, timeout } from "rxjs/operators";

export enum DEVICE_NETWORK_STATE {
    UNKNOWN,
    CONNECTED,
    DISCONNECTED
}

@Injectable({
  providedIn: 'root'
})
export class DeviceNetworkService {
    constructor(private http: HttpClient) {}

    async connectivityCheck() {
        const url = 'https://' + HOST;
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.set('X-Skip-Interceptor', 'true');
        let retryCount = 0;
        return this.http.head(url, { responseType: 'text', headers }).pipe(
            timeout(8000),
            retryWhen(errors =>
              errors.pipe(
                tap((e: any) => {
                  // 401 means the server is reachable (auth required) — stop retrying immediately.
                  if (e.status === 401 || retryCount > 0) {
                    throw e;
                  } else {
                    retryCount++;
                  }
                }),
                delay(200)
              )
            ),
            map(() => true),
            catchError(
                e => {
                    // Any 401 means the server responded — device is online.
                    if (e.status === 401) {
                        return of(true);
                    } else {
                        return of(false);
                    }
                }
            )
        ).toPromise();
    }    
}
